function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.7,
  cx: 12,
  cy: 12,
  r: 11.25,
  stroke: "#fff",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.94 11.541a.5.5 0 010 .918L10.7 14.296a.5.5 0 01-.699-.46v-3.673a.5.5 0 01.699-.459l4.241 1.837z",
  fill: "#fff"
});

var SvgButtonIconLeft = function SvgButtonIconLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgButtonIconLeft;